export class Usuario{
    idUsuario:number;
    usuario:string;
    password:string;
    constructor(){
        this.idUsuario = 0;
        this.usuario = '';
        this.password = '';
    }
}